import React, { memo, useEffect, useState } from "react";
import { FaFileUpload } from "react-icons/fa";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
  Button,
  Textarea,
} from "@material-tailwind/react";
import { useParams } from "react-router-dom";
import apiService from "../../../services/apiService";
import { useToast } from "../../../context/ToastContext";
import ReorderImages from "./Reorder";
import imageCompression from "browser-image-compression";

function Icon({ open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const Question = memo(({ question, saveDB, taskId }) => {
  const [images, setImages] = useState(question.imagesArr);
  const [answer, setAnswer] = useState(question.answer);
  //const [tempImages,setTempImages]=useState([])
  const [open, setOpen] = useState(false);
  //const taskId='633e89dcfa356a6094c60d6e' //useParams().id
  const [savedJson, setSavedJson] = useState(
    JSON.stringify(question.imagesArr),
  );

  let currentJson = JSON.stringify(question);
  //const isChanged = currentJson !== savedJson;
  const MAX_FILES = 5;

  const handleOpen = (value) => setOpen(open === true ? false : true);
  const { showSuccess, showError, showInfo, showWarning } = useToast();

  const options = {
    maxSizeMB: 1,
    useWebWorker: true,
  };

  function handleUpload(e) {
    const files = Array.from(e.target.files);

    if (images.length + files.length > MAX_FILES) {
      alert(`You can only upload up to ${MAX_FILES} images.`);
      return;
    }

    const newImages = files.map((file) => URL.createObjectURL(file));

    //setTempImages((prev) => [...prev, ...newImages]);
    setImages((prev) => [...prev, ...newImages]);
  }

  useEffect(() => {
    setImages(question.imagesArr);
    setAnswer(question.answer);
    setSavedJson(
      JSON.stringify({
        imagesArr: question.imagesArr,
        answer: question.answer,
      }),
    );
    //currentJson=JSON.stringify(question.imagesArr)
  }, [question]);

  async function handleReorder(reOrderedImages) {
    //saveDB(reOrderedImages,question.questionNum,'reorder')
    setImages(reOrderedImages);
    //setSavedJson(JSON.stringify(reOrderedImages))
  }

  async function handleSubmit() {
    console.log("images", images);
    const files = [];
    let allImages = await Promise.all(
      images.map(async (image, i) => {
        console.log(image);
        if (image.startsWith("blob:")) {
          const response = await fetch(image);
          let blob = await response.blob();
          blob = await imageCompression(blob, options);
          files.push(blob);
          return {
            fileName: `image_${Date.now() + i}`,
            fileType: blob.type,
            taskId: taskId,
          };
        }
        return image;
      }),
    );

    let fileData = allImages.filter((item) => typeof item === "object");
    console.log("fileData", fileData);

    try {
      let uploadedUrls;
      let flag;
      if (fileData.length > 0) {
        let res = await apiService.request_old(
          "/i/file/get-b2-uploadurl/multiple",
          { method: "POST", body: JSON.stringify(fileData) },
        );
        console.log(res);
        const urls = res;

        const uploadPromises = urls.map(async (fileUrl, i) => {
          const file = files[i]; //tempImages[i].file;
          await fetch(fileUrl.uploadUrl, {
            method: "PUT",
            headers: { "Content-Type": file.type },
            body: file,
          });
          return fileUrl.publicUrl;
        });

        uploadedUrls = await Promise.all(uploadPromises);
        //flag='upload';
        let index = 0;

        allImages = allImages.map((element) => {
          if (typeof element === "object") {
            element = uploadedUrls[index];
            index++;
          }
          return element;
        });
        console.log("Update images array", allImages);
        uploadedUrls = allImages;
      } else {
        uploadedUrls = [...images];
        //flag='reorder';
      }

      await saveDB(uploadedUrls, question.questionNum, answer, flag);
      //setTempImages([]);
      //setSavedJson(JSON.stringify(images));

      showSuccess(`${uploadedUrls.length} Images Saved`);
    } catch (err) {
      console.log(err);
      showError("Upload Failed");
    }
  }

  return (
    <div className="p-2 rounded">
      <Accordion open={open} icon={<Icon id={1} open={open} />}>
        <AccordionHeader onClick={() => handleOpen()}>
          <div className="flex justify-start gap-12">
            <span>Q-{question.questionNum}</span>
            {images.length === 0 ? null : (
              <span>{images.length} Images Uploaded</span>
            )}
          </div>
        </AccordionHeader>

        <AccordionBody>
          <div className="flex flex-col">
            <div className="mb-3">
              <Textarea
                variant="outlined"
                size="md"
                label="Answer"
                color="blue"
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
              />
            </div>

            <div>
              <div className="flex flex-col sm:flex-row sm:justify-start sm:gap-12 ">
                <span className="text-lg">You can select upto 5 images</span>

                <div>
                  <label className="text-3xl">📁</label>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleUpload}
                    className=""
                  />
                </div>

                <div className="md:hidden">
                  <label className="text-3xl">📷</label>
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment" // "user" for front camera, "environment" for back camera
                    onChange={handleUpload}
                  />
                </div>
              </div>

              <div className="flex gap-4">
                {/* {images.length>0&&(<Button onClick={()=>reOrder(images,question.questionNum)}>
                    Reorder
                  </Button>)} */}
                {savedJson !=
                  JSON.stringify({ imagesArr: images, answer: answer }) && (
                  <Button onClick={handleSubmit}>Save</Button>
                )}
              </div>
            </div>

            <div>
              <div className="flex flex-col pt-5 font-thin">
                {/* {images.length>0?images.map((url, idx) => (
                    <div key={idx} className="border rounded-lg overflow-hidden">
                      <img
                        src={url}
                        alt={`upload-${idx}`}
                        className=""
                      />
                    </div>
                  )):null} */}
                <ReorderImages urls={images} onReorder={handleReorder} />
              </div>
            </div>
          </div>
        </AccordionBody>
      </Accordion>
    </div>
  );
});

export default Question;
